import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-3" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-print" })
], -1)
const _hoisted_2 = [
  _hoisted_1
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.IsPrint())
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(`btn btn-icon btn-bg-light-${$props.color} btn-active-color-${$props.color} btn-sm me-1`)
      }, _hoisted_2, 2))
    : _createCommentVNode("", true)
}